import { RecursionView, useViewModel, View } from '@rehaje/react'
import { useEffect } from 'react'

import { SchemaModel } from '../models'

import type { ViewModel } from '@rehaje/core'
import type { FC } from 'react'

export interface FormProps {
  form: undefined | ViewModel
}

export const Form: FC<FormProps> = (props) => {
  const parent = useViewModel()
  const store = props.form?.__r_store
  useEffect(() => {
    if (parent instanceof SchemaModel) {
      store?.effect()
    }
  }, [store])
  if (!props.form) return null
  if (parent instanceof SchemaModel) {
    if (store?.node) {
      return <RecursionView node={store.node} />
    }
    return null
  }
  return <View store={props.form.__r_store} />
}
